export default function ({ route, store }) {
  if (process.client && typeof window != "undefined") {
    store.dispatch("getAppVersion");
  }
}
